import script from "./posterList.vue?vue&type=script&lang=ts&setup=true"
export * from "./posterList.vue?vue&type=script&lang=ts&setup=true"

import "./posterList.vue?vue&type=style&index=0&id=27b04bf4&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27b04bf4"]])

export default __exports__